import React from "react";
import Bancontact from '../../../assets/svg/bancontact.svg';
import FrameBlockResult from '../FrameBlockResult';
import { ApmsTypes } from "../../../constants";

const BancontactResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.Bancontact} icon={Bancontact} />
    )
}

export default BancontactResult;